import React, { useContext, createContext, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Header from './Components/Header/Header.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './assets/css/portal.css';
import Home from './Pages/Index';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Map from './Pages/Map';
import Profile from './Components/User/Profile';
import Logout from './Components/User/Logout';
import Admin from './Admin/Pages/Index';
import Users from './Admin/Pages/Users/Index';
import UpdateUser from './Admin/Pages/Users/Update';
import CreateUser from './Admin/Pages/Users/Create';
import DeleteUser from './Admin/Pages/Users/Delete';
import UserDetails from './Admin/Pages/Users/Details';
import AllRoles from './Admin/Pages/Roles/Index';
import CreateRole from './Admin/Pages/Roles/Create';
import UpdateRole from './Admin/Pages/Roles/Update';
import DetailsRole from './Admin/Pages/Roles/Details';
import DeleteRole from './Admin/Pages/Roles/Delete';
import AllAppointments from './Admin/Pages/Appointments/Index';
import CreateAppointment from './Admin/Pages/Appointments/Create';
import UpdateAppointment from './Admin/Pages/Appointments/Update';
import DetailsAppointment from './Admin/Pages/Appointments/Details';
import DeleteAppointment from './Admin/Pages/Appointments/Delete';
import { RequireAuth, AuthProvider } from 'react-auth-kit';
import { CookiesProvider } from 'react-cookie';



export default function App() {


  return (
    <>
    <CookiesProvider>
      <AuthProvider authType={'cookie'}
        authName={'_auth'}
        cookieDomain={window.location.hostname}>
        <Router>

          <Header />

          <Routes>

            <Route path="/hospital-portal" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/Register" element={<Register />} />
            <Route path="/Map" element={<Map />} />
            <Route path="/User" />
            <Route path="/User/Profile" element={<Profile />} />
            <Route path="/User/Logout" element={<Logout />} />
            <Route path="/Admin" element={<Admin />}>

            </Route>
            <Route path="/Admin/Users" element={<Users />} />
            <Route path="/Admin/Users/Create" element={<CreateUser />} />
            <Route path="/Admin/Users/Update/:id" element={<UpdateUser />} />
            <Route path="/Admin/Users/Delete/:id" element={<DeleteUser />} />
            <Route path="/Admin/Users/Details/:id" element={<UserDetails />} />
            <Route path="/Admin/Roles" element={<AllRoles />} />
            <Route path="/Admin/Roles/Create" element={<CreateRole />} />
            <Route path="/Admin/Roles/Update/:id" element={<UpdateRole />} />
            <Route path="/Admin/Roles/Details/:id" element={<DetailsRole />} />
            <Route path="/Admin/Roles/Delete/:id" element={<DeleteRole />} />\
            <Route path="/Admin/Appointments" element={<AllAppointments />} />
            <Route path="/Admin/Appointments/Create" element={<CreateAppointment />} />
            <Route path="/Admin/Appointments/Update/:id" element={<UpdateAppointment />} />
            <Route path="/Admin/Appointments/Details/:id" element={<DetailsAppointment />} />
            <Route path="/Admin/Appointments/Delete/:id" element={<DeleteAppointment />} />
          
          </Routes>

        </Router>
      </AuthProvider>
    </CookiesProvider>
    </>
  )
}